import templateUrl from "webmodals/modal.htm";
import basicController from "servicestack/basic.controller.properties";

export class ModalController {
  constructor($element, $transclude) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$element = $element;
    $ctrl.$transclude = $transclude;
  }

  isSlotFilled(slot) {
    return $transclude.isSlotFilled(slot);
  }

  $maxHeight() {
    const $ctrl = this;
    if ($ctrl.preventAutoHeight) {
      return false;
    }
    return $ctrl.$pageConfig.height - ($ctrl.maxHeightBuffer || 180);
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.modalContent = $ctrl.$element[0].closest(".modal-content");
    $ctrl.modalContent.id = "modal-content";
  }
}

export default {
  bindings: {
    modal: "<instance",
    title: "@modalTitle",
    subTitle: "@",
    hideHeader: "@",
    hideCloseButton: "@",
    hideFooter: "<?",
    onDismiss: "&",
    onClose: "&",
    preventAutoHeight: "<?",
    maxHeightBuffer: "<?",
    modalContent: "=?",
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
  transclude: {
    header: "?modalHeader",
    rawHeader: "?modalRawHeader",
    //title: '?modalTitle',
    body: "?modalBody",
    raw: "?modalRaw",
    rawFooter: "?modalRawFooter",
    footer: "?modalFooter",
  },
  controller: ModalController,
};
